import { hideOverlay, showOverlay, whenNotShownInOverlay$ } from './Overlay';
export default (($) => {
    console.log('UNTUCKit : Module : VideoModal : loaded');
    const dom = {};
    const cacheDom = () => {
        dom.videoModal = $('[data-video-modal]');
        dom.videoModalIframe = $('[data-video-modal-iframe]');
    };
    const openVideo = (event) => {
        const $target = $(event.currentTarget);
        const videoID = $target.attr('data-video-id');
        const sourceURI = `https://www.youtube.com/embed/${videoID}/?rel=0;&autoplay=1`;
        dom.videoModal.addClass('is-active');
        dom.videoModalIframe.attr('src', sourceURI);
        showOverlay('video');
    };
    const closeVideo = () => {
        if (!dom.videoModal.hasClass('is-active')) {
            return;
        }
        hideOverlay();
        dom.videoModal.removeClass('is-active');
        dom.videoModalIframe.attr('src', '');
    };
    const bindUIActions = () => {
        $(document).on('click', '[data-video-id]', openVideo);
        $(document).on('click', '.js-close-modal', closeVideo);
        whenNotShownInOverlay$('video').subscribe(() => closeVideo());
    };
    const init = () => {
        console.log('UNTUCKit : Module : VideoModal : init');
        cacheDom();
        bindUIActions();
    };
    return { init };
})($);
